export const SHOW_ELEV8_PRICES_UPPERFUNNEL = "show_elev8_prices_upperfunnel";
export const SHOW_ELEV8_WITH_TOTALPRICE_ON_CONSUMER = "show_elev8_with_totalprice_on_consumer";
